import { Field, Form, Formik } from 'formik';
import { React, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TextInput, Button, Radio, Toggler } from '@components';
import { ConversaoMATInitialValues, ConversaoMATSchema } from '@schemas';
import { obterPeritosRequest } from '@store/requerimento/actions';
import { enviaFormRequest } from '@store/user/actions';
import { constantesRequerimentos } from '@utils';

const {
  VITALICIA_S_R_RCM,
  VITALICIA_C_R_RCM,
  CONJUGADA_S_R_RCM,
  CONJUGADA_C_R_RCM,
} = constantesRequerimentos;

export const ConversaoMAT = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(obterPeritosRequest());
  }, [dispatch]);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        <p className="mb-3">
          Venho, por meio deste, requerer à Fundação Forluminas de Seguridade
          Social - FORLUZ, a conversão da Melhoria de Aposentadoria por Tempo de
          Contribuição, Especial ou por Idade – MAT, que venho recebendo sob a
          forma de Renda Variável, em Renda Vitalícia, nos termos do Regulamento
          do Plano Misto de Benefícios Previdenciários da Forluz (Plano B) e das
          normas vigentes.
        </p>
        <Formik
          validateOnMount
          initialValues={ConversaoMATInitialValues}
          validationSchema={ConversaoMATSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ values, handleSubmit, isValid }) => (
            <Form>
              <div className="row">
                <div className="col-md-12 col-lg-6 mb-3">
                  <p className="label mb-3">Opção benefício</p>
                  <Field
                    className="mb-3"
                    name="opcaoBeneficio"
                    component={Radio}
                    color="orange"
                    value={VITALICIA_S_R_RCM}
                    label={VITALICIA_S_R_RCM}
                  />
                  <Field
                    className="mb-3"
                    name="opcaoBeneficio"
                    component={Radio}
                    color="orange"
                    value={VITALICIA_C_R_RCM}
                    label={VITALICIA_C_R_RCM}
                  />
                  <Field
                    className="mb-3"
                    name="opcaoBeneficio"
                    component={Radio}
                    color="orange"
                    value={CONJUGADA_S_R_RCM}
                    label={CONJUGADA_S_R_RCM}
                  />
                  <Field
                    className="mb-3"
                    name="opcaoBeneficio"
                    component={Radio}
                    color="orange"
                    value={CONJUGADA_C_R_RCM}
                    label={CONJUGADA_C_R_RCM}
                  />
                </div>
              </div>

              <div className="row">
                <p className="mb-4">
                  Ao optar pela conversão da Renda Variável em Renda Vitalícia,
                  declaro ter pleno conhecimento de que: O benefício será
                  convertido a partir do saldo existente em minha conta de
                  aposentadoria no momento da conversão, de acordo com o
                  Regulamento do Plano e normas em vigor, que declaro conhecer e
                  com eles concordar. A conversão da Renda Variável em Renda
                  Vitalícia, oriunda da MAT Conjugada, seguirá a opção inicial
                  de reversão em Renda Continuada por Morte – RCM. Findado o
                  prazo regulamentar, não será permitida nova solicitação. A
                  conversão da Renda Variável em Renda Vitalícia é irreversível.
                </p>
                <Field
                  className="mb-3"
                  name="declaracao"
                  component={Toggler}
                  label="Declaração"
                />
              </div>

              {(values.opcaoBeneficio === VITALICIA_C_R_RCM ||
                values.opcaoBeneficio === CONJUGADA_C_R_RCM) && (
                <div className="row">
                  <div className="col-md-12 col-lg-6 mb-3">
                    <Field
                      label="Percentual RCM"
                      name="percentualRCM"
                      component={TextInput}
                      min={1}
                      max={100}
                      type="number"
                    />
                  </div>
                </div>
              )}

              {(values.opcaoBeneficio === CONJUGADA_C_R_RCM ||
                values.opcaoBeneficio === CONJUGADA_S_R_RCM) && (
                <>
                  <div className="row">
                    <div className="col-md-12 col-lg-6 mb-3">
                      <Field
                        label="Percentual do saldo de contas em Renda Vitalícia"
                        name="percentualSaldoDeContasEmRendaVitalicia"
                        component={TextInput}
                        min={50}
                        max={100}
                        type="number"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-lg-6 mb-3">
                      <Field
                        label="Percentual retirada mensal"
                        name="percentualRetiradaMensal"
                        component={TextInput}
                        min={1}
                        max={100}
                        type="number"
                      />
                    </div>
                  </div>
                </>
              )}

              <hr className="mt-32 mt-xs-0 mb-32" />
              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
